import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import GroupIcon from '@mui/icons-material/Group';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import * as React from 'react';
import { useContext } from 'react';
import { hasProduct } from '../../../../shared-components/contexts/InstitutionContext';
import LaunchDarklyContext from '../../../../shared-components/contexts/LaunchDarklyContext';
import LinkTile from './LinkTile';
import SettingsGroup from './SettingsGroup';

interface UserManagementSettingsProps {
  linkIconTileClassName: string;
}

const UserManagementSettings = ({
  linkIconTileClassName,
}: UserManagementSettingsProps) => {
  const launchDarkly = useContext(LaunchDarklyContext);

  return (
    <SettingsGroup title="Users">
      <LinkTile to="/management/users" text="Users And Roles">
        <GroupIcon className={linkIconTileClassName} />
      </LinkTile>
      {hasProduct('CourseEvaluation') && (
        <LinkTile
          href="/beacon/settings/tools/midtermgradeupload"
          text="Manage Academic Record"
        >
          <FolderSharedIcon className={linkIconTileClassName} />
        </LinkTile>
      )}
      {hasProduct('CourseEvaluation') && (
        <LinkTile href="/beacon/settings/absence" text="Manage Absences">
          <AccessAlarmIcon className={linkIconTileClassName} />
        </LinkTile>
      )}
    </SettingsGroup>
  );
};

export default UserManagementSettings;
